import * as ApikoApi from '../../api/apiko-api';
import { fetchUsersSuccess } from '../actions/users';
import { updateProfileRequest } from '../actions/profile-settings';

/**
 * handleUpdateProfile :: Object -> Fund -> Promise Error _
 */
export const handleUpdateProfile = data => dispatch =>
  Promise.resolve(dispatch(updateProfileRequest()))
    .then(() => ApikoApi.updateProfile(data))
    // update a user document in the state
    .then(result => dispatch(fetchUsersSuccess({ users: [result.user] })));



// WEBPACK FOOTER //
// ./src/redux/thunk/profile-settings.js